import { pickT } from "@repo/shared";
import { T } from "./advisor-review-reason-text.i18n";

/**
 * QL-314 — the client-facing line for one goal's advisor-review reason.
 * Unknown / absent reasons fall back to the generic line, so a reason added
 * on the server before its copy exists here still reads sensibly. `lang` is
 * the flow language.
 */
export function advisorReviewReasonText(reason: string | undefined, lang: string): string {
  const t = pickT(T, lang);
  switch (reason) {
    case "volatility_bound_breach":
      return t.advisorReviewVolatilityBreach;
    case "volatility_bound_not_accepted":
      return t.advisorReviewVolatilityNotAccepted;
    case "equity_share_bound_breach":
      return t.advisorReviewEquityShareBreach;
    case "equity_share_bound_not_accepted":
      return t.advisorReviewEquityShareNotAccepted;
    case "volatility_no_risk_score":
    case "volatility_not_evaluable":
    case "equity_share_no_risk_score":
    case "equity_share_not_evaluable":
      return t.advisorReviewNotEvaluable;
    // QL-375 — the mandate's five reasons all read as the generic review line:
    // the measure stays unnamed for the client.
    case "mandate_breach":
    case "mandate_not_accepted":
    case "mandate_no_risk_score":
    case "mandate_not_evaluable":
    case "mandate_required_missing":
      return t.advisorReviewGoalDefault;
    // QL-576 — the client must not learn bank-account details (which accounts,
    // which wrapper type); the advisor resolves it, so this reads as the
    // generic review line, same as every other reason that keeps server-side
    // specifics off the public flow.
    case "followup_account_wrapper_conflict":
      return t.advisorReviewGoalDefault;
    default:
      return t.advisorReviewGoalDefault;
  }
}
